import { createSlice } from "@reduxjs/toolkit";
export const postingScheduleSlice = createSlice({
  name: "postingScheduleReducer",
  initialState: {
    currentPage: 1,
    filters: {
      startdate: "",
      enddate: "",
      pageName: "",
      format: "",
      scheduleDate: "",
      oldSchedule: "",
      scheduleGroupId: "",
      day: "",
    },
  },
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setReduxFilters: (state, action) => {
      state.filters = action.payload;
    },
  },
});

export const { setCurrentPage, setReduxFilters } = postingScheduleSlice.actions;
export default postingScheduleSlice.reducer;
